import { StyleSheet, Text, View } from 'react-native';

import { Button } from '@/src/components/Button';
import { colors } from '@/src/theme/colors';
import { spacing } from '@/src/theme/spacing';

type ErrorViewProps = {
  title?: string;
  message: string;
  retryLabel?: string;
  onRetry?: () => void;
};

export function ErrorView({
  title = 'Something went wrong',
  message,
  retryLabel,
  onRetry,
}: ErrorViewProps) {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>{title}</Text>
      <Text style={styles.message}>{message}</Text>
      {onRetry ? (
        <Button
          title={retryLabel ?? 'Try again'}
          variant="secondary"
          onPress={onRetry}
        />
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    gap: spacing.md,
    paddingVertical: spacing.xl,
  },
  title: {
    color: colors.text,
    fontSize: 20,
    fontWeight: '800',
  },
  message: {
    color: colors.mutedText,
    fontSize: 16,
    lineHeight: 22,
  },
});
